import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Tooltip } from 'next-common-lib';
import i18n from 'i18n';
import DeleteButton from 'components/Common/Buttons/DeleteButton';
import * as gnbMenuActions from 'redux/ducks/GnbMenu/GnbMenuDucks';

export const GnbViewBox = ({ keyValue, item, isGnb }) => {
  const dispatch = useDispatch();

  return (
    <div key={keyValue} className={isGnb ? `view-box gnb-menu` : `view-box`}>
      <Tooltip componentType="move" label={[`${item.titleKo}`]} placement="bottom">
        <div className="view-box-content">
          <div className="view-option">
            <div className="tit">
              <h1 className="main-text">
                {isGnb ? i18n.t('BTY_W_T_CREATE_MENU_T_GENERAL') : i18n.t('BTY_W_T_CREATE_MENU_T_GROUP')}
              </h1>
            </div>
          </div>
          <p className="main-text">{item.titleKo}</p>
          <p className="main-text">{item.titleEn}</p>
        </div>
      </Tooltip>
      <DeleteButton
        handleOnclick={() =>
          dispatch(
            gnbMenuActions.deleteGnbMenu({
              menuLabel: item.menuLabel,
              currentCompId: item.adminCompId,
              menuType: item.menuType,
            }),
          )
        }
      />
    </div>
  );
};

GnbViewBox.propTypes = { item: PropTypes.object.isRequired, isGnb: PropTypes.bool, keyValue: PropTypes.number };
GnbViewBox.defaultProps = { isGnb: false, keyValue: 0 };
export default GnbViewBox;
